import React from "react";
import { Container } from "../styles/ResumeStyles";
import Bio from "../components/resume/Bio";
import Objective from "../components/resume/Objective";
import Projects from "../components/resume/Projects";
import Experience from "../components/resume/Experience";
import Education from "../components/resume/Education";
import AdditionalInfo from "../components/resume/AdditionalInfo";

const Resume = () => {
  return (
    <Container>
      <Bio />
      <Objective />
      <Projects />
      <Experience />
      <Education />
      <AdditionalInfo />
    </Container>
  );
};

export default Resume;
